import Vue from 'vue'
import httpManager from '../../util/common'
import * as d3 from 'd3'
import {reportYear} from '../../util/util'
let vm = {
  name: 'ESGIndustryGradeBarChart',
  delimiters: ['{', '}'],
  props: {
    oaid: String,
    type: String
  },
  data: () => {
    return {
      data: [],
      rawData: [],
      responseData: [],
      report: reportYear.report_year_now,
      colorRaw: ['#A72D2D', '#E1B52C', '#4C964B', '#4F7FC7', '#6D5DE1'],
      reportRagetTypew: reportYear.report_years,
      company: {
        id:null,
        name:null
      },
      companys: [],
      companyFilter: [],
      duration: 5,
      reports: reportYear.report_options,
      midData: {},
      securiteisType: "",
      page: {
        pagenum: 1,
        pagesize: 10,
        total: 0,
        pagerCount:3,
        align: 'center',
        layouts: ['PrevPage', 'Number','NextPage'],
        perfect: true,
      },
      myloadng: false,

    }
  },
  methods: {
    focusEvent1() {
      this.companyFilter = this.companys
      this.$refs.xDown1.showPanel()
    },
    keyupEvent1() {
      const {company} = this
      this.companyFilter = company.name ? this.companys.filter(item => item.label.indexOf(company.name) > -1) : this.companys
    },
    selectEvent1(item) {
      this.company.id = item.value
      this.company.name = item.label
      this.$refs.xDown1.hidePanel().then(() => {
        this.companyFilter = this.companys
      })
    },
    send(oaid, name, report) {
      if(!report){
        let columns = reportYear.getReport(this.report, this.duration)
        report = columns
      }
      this.$emit("zifu", oaid, name, report);
    },
    calData(data) {
      let self = this
      let rawdata = data
      let reports = reportYear.getReport(self.report, self.duration)
      self.midData = {}
      self.companys = [{label: this.$t('supplychain.all_companies'), value: ''},]
      rawdata.forEach(function (a) {
        if ((self.securiteisType == "3" && a['bond']=="1") || (self.securiteisType == "2" && a['ticker']) || !self.securiteisType) {
          if (a['oaid'] && reports.includes(a['reporting_year'])) {
            if (!(a['oaid'] in self.midData)) {
              self.midData[a['oaid']] = {
                name: a['name'],
                oaid: a['oaid'],
                ticker: a['ticker'],
                bond: a['bond'],
                total: 0
              }
              self.companys.push({label: a['name'], value: a['oaid']})
            }
            if(!(a['reporting_year'] in self.midData[a['oaid']])){
              self.midData[a['oaid']][a['reporting_year']] = 0
            }

            self.midData[a['oaid']][a['reporting_year']] += a['amount_cny']
            self.midData[a['oaid']]['total'] += a['amount_cny']
          }
        }
      })
      let midList = [];

      for (let k in self.midData) {
        // if (self.midData[k]['total'] != 0) {
          midList.push(self.midData[k])

        // }
      }
      midList.sort(function (x, y) {
        if (!y['oaid']) {
          return -1;
        }
        if (x['total'] < y['total']) {
          return 1;
        }
        if (x['total'] > y['total']) {
          return -1;
        }
        return 0;
      });
      self.page.total = midList.length
      self.page.pagenum = 1
      self.rawData = midList
      if (midList.length > 0) {
        self.send(midList[0].oaid, midList[0].name)
      }
      self.onChange({currentPage: 1})
      self.drawChart()
    },
    getESGData() {
      let type = this.type
      let oaid = this.oaid
      let params = new Map()
      params.set("oaid", oaid)
      let self = this
      self.myloadng = true
      let pathVars = new Map()
      pathVars.set("type", type)
      httpManager("sc_bar_data", params, null, null, pathVars)
        .then(response => {
          self.responseData = response.data.data
          self.calData(self.responseData)
          self.myloadng = false
        })
        .catch(error => {
          console.log(error)
          self.myloadng = false
        })
    },
    changePage(data) {
      let start = (this.page.pagenum - 1) * this.page.pagesize
      let end = this.page.pagenum * this.page.pagesize
      end = this.page.total > end ? end : this.page.total
      return data.slice(start, end)
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.data = this.changePage(this.rawData)
      this.drawChart()
    },
    changeCompanyReport() {
      if (this.company.id) {
        this.data = [this.midData[this.company.id]]
        this.send(this.company.oaid, this.company.name)
        this.drawChart()
      } else {
        this.send(this.rawData[0]['oaid'], this.rawData[0]['name'])
        this.onChange({currentPage: 1})
      }

    },
    drawChart() {
      let self = this
      let columns = reportYear.getReport(self.report, self.duration)
      let data = self.data
      let length = data.length
      let series = d3.stack().keys(columns.slice(0))(data).map(d => (d.forEach(v => v.key = d.key), d))
      d3.select("#sc_bar_chart").select('*').remove()
      d3.select("#sc_bar_chart_legend").select('*').remove()
      let height = 800
      let width = 1700
      let fontsize = 14
      let svg = d3.select("#sc_bar_chart").append("svg").attr("viewBox", [0, 0, width, height])
      let svg_legend = d3.select("#sc_bar_chart_legend").append("svg").attr("viewBox", [0, -40, width, 80])
      let margin = ({top: 40, right: 17, bottom: 41, left: 20})
      let formatValue = x => isNaN(x) || !x ? "N/A" : x.toLocaleString("en")
      let color = d3.scaleOrdinal()
        .domain(series.map(d => d.key))
        .range(self.colorRaw.slice(0, series.length))
        .unknown("#ccc")
      let yAxis = g => g
        .attr("transform", `translate(${margin.left},0)`)
        .call(d3.axisLeft(y).tickSizeOuter(0))

        .call(g => g.selectAll(".tick text")
          .call(function (t) {
            t.each(function (d) { // for each one
              var self = d3.select(this);
              var s = self.text().split('#@')[1].split('@#');  // get the text and split it
              self.text(''); // clear it out
              self.style("text-anchor", "start")
              self.append("tspan") // insert two tspans
                .attr("x", 0)
                .attr("y", -30)
                .attr("dy", ".8em")
                .text(s[0]);
              self.append("tspan")
                .attr("x", () => {
                  let len = getTextLength(s[0], fontsize)
                  return len + 20
                })
                .attr("y", -30)
                .attr("dy", ".8em")
                .attr("color", "red")
                .text(s[1]);
            })
          }).attr("font-size", fontsize).attr('cursor', 'pointer').on('click', clickName))
        .call(g => g.selectAll(".domain").remove())

      function changeTxt(self, oaid, ticker, bond, name) {
        let re = oaid + "#@" + name
        if (ticker) {
          re +=  "@#" + (bond ? self.$t('supplychain.bond1') + "        " : "") + self.$t('supplychain.stock1') + ":" + ticker
        } else {
          re += bond ?  "@#" + self.$t('supplychain.bond1') : ""
        }
        return re
      }

      function getTextLength(str, fontsize) {
        let curLen = 0
        let strLen = str.length
        for (let i = 0; i < str.length; i++) {
          const code = str.charCodeAt(i)
          const pixelLen = code > 255 ? fontsize : fontsize / 2
          curLen += pixelLen
        }
        return curLen
      }

      let xAxis = g => g
        .attr("transform", `translate(0,${height - margin.top})`)
        .call(d3.axisBottom(x).ticks(width / 100, "s").tickFormat(d => d > 100000000 ? d / 100000000 + "亿元" : d / 10000 + "万元"))
      // .call(g => g.selectAll(".domain").remove())
      // .call(g => g.selectAll(".tick text").remove())
      function clickRect(event, d) {
        if (event.defaultPrevented) return; // dragged
        self.send(d.data.oaid, d.data.name, d.key)
      }

      function clickName(event, d) {
        if (event.defaultPrevented) return; // dragged
        self.send(d.split('#@')[0], d.split('#@')[1].split('@#')[0])
      }

      let y = d3.scaleBand()
        .domain(data.map(d => changeTxt(this, d.oaid, d.ticker, d.bond, d.name)))
        .range([margin.top, height - margin.bottom])
        .padding(0.5)
      let x = d3.scaleLinear()
        .domain([0, d3.max(series, d => d3.max(d, d => d[1]))])
        .range([margin.left, width - margin.right])
      let legend = svg => {
        const g = svg
          .attr("transform", `translate(${margin.left},0)`)
          .attr("text-anchor", "end")
          .attr("font-family", "sans-serif")
          .attr("font-size", 16)
          .selectAll("g")
          .data(series)
          .join("g")
          .attr("transform", (d, i) => `translate(${i * 150},0)`);

        g.append("rect")
          .attr("y", 0)
          .attr("width", 70)
          .attr("height", 30)
          .attr("fill", d => color(d.key));

        g.append("text")
          .attr("x", 130)
          .attr("y", 15)
          .attr("dy", "0.35em")
          .text(d => d.key + this.$t('supplychain.year1'));
      }
      svg_legend.append("g").call(legend);
      svg_legend.node();

      svg.append("g")
        .selectAll("g")
        .data(series)
        .join("g")
        .attr("fill", d => color(d.key))
        .selectAll("rect")

        .data(d => d)
        .join("rect").on('click', clickRect)
        .attr("x", d => x(d[0]))
        .attr("y", (d, i) => y(changeTxt(this, d.data.oaid, d.data.ticker, d.data.bond, d.data.name)) + (y.bandwidth() * 0.8 > 30 ? ((y.bandwidth() * 0.5) - 15) : (y.bandwidth() * 0.3)))
        .attr("width", d => x(d[1]) - x(d[0]))
        .attr("height", y.bandwidth() * 0.8 > 30 ? 30 : y.bandwidth() * 0.8)
        .attr('cursor', 'pointer')
        .append("title")
        .text(d => `${d.data.name} ${d.key} ${formatValue(d.data[d.key])}`)

      // svg.append("g")
      //   .attr("fill", "white")
      //   .attr("text-anchor", "end")
      //   .attr("font-family", "PingFang SC")
      //   .attr("font-size", 12)
      //   .selectAll("text")
      //   .data(data)
      //   .join("text")
      //   .attr("x", d => x(d[0]))
      //   .attr("y", (d, i) => y(d.data.name))
      //   .attr("dy", "0.35em")
      //   .attr("dx", -4)
      //   .text(d => formatValue(d.data[d.key]))
      //   .call(text => text.filter(d => x(d.count) - x(0) < 20) // short bars
      //     .attr("dx", +4)
      //     .attr("fill", "black")
      //     .attr("text-anchor", "start"));
      svg.append("g")
        .call(xAxis);
      svg.append("g")
        .call(yAxis);
      svg.node();
    }
  },
  mounted() {
    this.getESGData()
    this.companys = [{label: this.$t('supplychain.all_companies'), value: ''},]
    // console.log('@@@@@',this.oaid);
  },
  watch: {
    'company.id': function () {
      this.changeCompanyReport()
    },
    report: function () {
      this.calData(this.responseData)
      this.changeCompanyReport()
    },
    duration: function () {
      this.calData(this.responseData)
      this.changeCompanyReport()
    },
    securiteisType: function () {
      this.calData(this.responseData)
      this.changeCompanyReport()
    },
  },
  computed:{
    getType(){
      if(this.type=='supplier'){
        return this.$t('supplychain.supplier')
      }else{
        return this.$t('supplychain.customer')
      }
    }
  }
}
Vue.component("sc-view-bar-chart", vm)
export default vm



// WEBPACK FOOTER //
// ./src/supplychain/js/sc_bar_chart.js